<template>
  <div class='EnbDestaques'>
    <div class="text" :style="{ color: Prefes.frentelojaCorFonte.color }">DESTAQUES</div>
    <div class="cont">
      <product-list
      v-for="(p, key) in Destaques"
      :key="key"
      :data="p"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProductList from './ProductList'
export default {
  name: 'EnbDestaques',
  components: { ProductList },
  data () {
    return {
      Destaques: []
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['GetDestaques'])
  },
  created () {
    this.GetDestaques()
      .then(res => {
        this.Destaques = res
      })
  }
}
</script>

<style scoped>
.EnbDestaques {
  width: 100%;
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
  width: 96%;
  padding: 2%;
}

/* grid de colunas fixas: o bloco fica centralizado e os cards que sobram na última linha ficam à esquerda */
.cont {
  width: 70%;
  /* height: 95%; */
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, 180px);
  justify-content: center;
  gap: 20px;
  padding: 20px 0;
  overflow: auto;
}

.cont > .ProductList {
  margin: 0;
}

@media (max-width: 500px) {
  .cont {
    width: 100%;
    gap: 10px;
  }
  
  .text {
    width: 90%;
    padding: 5%;
  }
}
</style>
